var map = {
	"./academy-dev.js": 196,
	"./academy-local.js": 197,
	"./academy-preprod.js": 198,
	"./academy.js": 195,
	"./dev-v2.js": 200,
	"./dev.js": 199,
	"./index.js": 46,
	"./local.js": 201,
	"./preprod.js": 202,
	"./prod.js": 203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;